package com.vamvisions.main.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.browser.window
import org.w3c.dom.events.Event

const val REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)"

/**
 * Whether the user asks for reduced motion. The first value is read synchronously, so it is already
 * right on the first render; later changes of the system setting update the state.
 */
@Composable
fun prefersReducedMotion(): State<Boolean> {
    val query = remember { window.matchMedia(REDUCED_MOTION_QUERY) }
    val reduced = remember { mutableStateOf(query.matches) }
    DisposableEffect(query) {
        val onChange: (Event) -> Unit = { reduced.value = query.matches }
        query.addEventListener("change", onChange)
        onDispose { query.removeEventListener("change", onChange) }
    }
    return reduced
}
